<div class="expense-modal-edit">
  <header class="base-modal__header">
    <div class="base-modal__header-content">
      <h1 class="base-modal__title">De-Itemize</h1>
      <p class="base-modal__subtitle">
        This will delete all related items and restore the original expense that
        existed before itemization occurred. This action is permanent and cannot
        be undone.
      </p>
    </div>
    <div class="base-modal__actions">
      <ng-content select="[modal-actions]"></ng-content>
    </div>
  </header>

  <div class="expense-modal-edit__body">
    <section class="expense-modal-edit__content">
      <!-- Cancel or Empty Trash -->
      <ems-base-button-group>
        <ems-base-button
          (click)="onCancel()"
          label="Cancel"
          buttonType="tertiary"
          variant="inverted"
        >
        </ems-base-button>
        <ems-base-button
          (click)="onConfirm()"
          label="Confirm"
          buttonType="primary"
          variant="destructive"
        >
        </ems-base-button>
      </ems-base-button-group>
    </section>
  </div>
</div>
